<template>
  <body data-spy="scroll" data-offset="80">
    <!-- Header -->

    <header id="main-header" class="header-one">
      <div class="bg-dark iq-ptb-10 header-top-bar">
        <div class="container">
          <div class="row">
            <div class="col-auto mr-auto">
              <ul>
                <li>
                  <a href="javascript:void(0)"
                    ><i class="fa fa-phone iq-mr-10" aria-hidden="true"></i
                    ><span class="iq-font-white">+250789326245</span></a
                  >
                </li>
              </ul>
            </div>
            <div class="col-auto">
              <div class="social-bar">
                <ul>
                  <li>
                    <a href="javascript:void(0)"
                      ><i class="fa fa-facebook" aria-hidden="true"></i
                    ></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)"
                      ><i class="fa fa-twitter" aria-hidden="true"></i
                    ></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)"
                      ><i class="fa fa-pinterest" aria-hidden="true"></i
                    ></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)"
                      ><i class="fa fa-google" aria-hidden="true"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav class="navbar navbar-expand-lg navbar-light">
              <a class="navbar-brand" href="/">
                <img
                  class="img-fluid logo_img"
                  id="logo_img"
                  src="images/logo-0001.png"
                  alt="#"
                />
              </a>
              <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="ion-navicon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto justify-content-end">
                  <li class="nav-item dropdown">
                    <a
                      id="navbarDropdown0"
                      href="#"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      class="nav-link dropdown-toggle"
                    >
                      Home</a
                    >
                    <div
                      aria-labelledby="navbarDropdown0"
                      class="dropdown-menu"
                    >
                      <a href="https://estaterwanda.com/" class="dropdown-item">
                        Estate Rwanda
                      </a>
                      <a href="https://kigaliselfdrive.com" class="dropdown-item">
                        Kigali Self Drive</a
                      >
                      <a href="https://kinezorclothing.com" class="dropdown-item">
                        Kinezor Clothing</a
                      >
                      <a href="https://kigalirwandacarhire.com" class="dropdown-item">
                        Rwanda Car Hire</a
                      >
                    </div>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#how-it-works">About</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#software-features">Service</a>
                  </li>
                  <!-- <li class="nav-item">
                    <a class="nav-link" href="#team">Team</a>
                  </li> -->
                  <li class="nav-item">
                    <a class="nav-link" href="#products">Products</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#contact">Contact</a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
    <!-- Header End -->
    <!-- Banner -->
    <section id="iq-home" class="iq-banner-12 overview-block-pt blue-bg">
      <div class="container">
        <div class="banner-text text-left">
          <div class="row justify-content-between">
            <div class="col-md-6 align-self-center">
              <h3 class="iq-font-white iq-tw-4">
                Tamba Group is
                <b>a Creative Idea Solution through Technology</b>
              </h3>
              <h5 class="iq-font-white iq-mtb-20">
                From web applications to mobile solutions, we deliver innovative technology
                that drives growth and success for businesses across Rwanda and beyond.
              </h5>

              <!-- Trust Indicators -->
              <div class="trust-indicators iq-mb-30">
                <div class="row">
                  <div class="col-md-4">
                    <div class="stat-item text-center">
                      <h4 class="iq-font-white iq-tw-6">50+</h4>
                      <p class="iq-font-white">Projects Completed</p>
                </div>
                  </div>
                  <div class="col-md-4">
                    <div class="stat-item text-center">
                      <h4 class="iq-font-white iq-tw-6">5+</h4>
                      <p class="iq-font-white">Years Experience</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="stat-item text-center">
                      <h4 class="iq-font-white iq-tw-6">100%</h4>
                      <p class="iq-font-white">Client Satisfaction</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="cta-buttons">
                <a href="#contact" class="button bt-black iq-mr-20">Get Free Consultation</a>
                <a href="#products" class="button bt-white">View Our Work</a>
              </div>
            </div>
            <div class="col-md-6">
              <div class="banner-video-wrapper">
                <video class="banner-video" autoplay muted loop playsinline>
                  <source src="images/video-bg.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <!-- <img
                class="banner-phone img-fluid center-block wow fadeInUp"
                src="images/product/mob.png"
                alt=""
              /> -->
            </div>
          </div>
        </div>
      </div>
      <div class="banner-objects">
        <span
          class="banner-objects-01"
          data-bottom="transform:translatey(50px)"
          data-top="transform:translatey(-50px);"
        >
          <img src="images/drive/03.png" alt="drive02" />
        </span>
        <span class="banner-objects-02 iq-fadebounce">
          <span class="iq-round"></span>
        </span>
        <span class="banner-objects-03 iq-fadebounce">
          <span class="iq-round"></span>
        </span>
        <span
          class="banner-objects-04"
          data-bottom="transform:translatex(100px)"
          data-top="transform:translatex(-100px);"
        >
          <img src="images/drive/04.png" alt="drive02" />
        </span>
      </div>
    </section>
    <!-- Banner End -->
    <!-- How it Works -->
    <section class="overview-block-pt">
      <div class="container" id="how-it-works">
        <div class="row iq-mt-10">
          <div class="col-sm-12">
            <div class="heading-title iq-mt-50">
              <h3 class="title iq-tw-7">Tamba Group</h3>
              <p style="font-size: 18px">
                Tamba Group is a dynamic company dedicated to delivering
                creative solutions through innovative technology. Our mission is
                to bridge the gap between ideas and impactful execution, helping
                businesses and individuals thrive in a technology-driven world.
                With a passion for innovation, we aim to simplify challenges,
                enhance productivity, and drive success through cutting-edge
                solutions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- How it Works -->

    <!-- Who is Sofbox ? -->
    <section class="how-works r-mt-40 overview-block-ptb">
      <div class="container">
        <div class="row flex-row-reverse">
          <div class="col-lg-8">
            <img
              class="iq-works-img pull-right img-fluid"
              src="images/about-us.jpeg"
              alt="drive01"
            />
          </div>
          <div class="col-lg-4 align-self-center">
            <span class="badge iq-badge blue-bg iq-font-white">About Us</span>
            <h6 class="iq-tw-6 iq-mb-15 iq-font-20">
              We Transforming Challenges Into Opportunities.
            </h6>
            <p class="iq-font-15">
              At Tamba Group, we believe that every challenge holds the
              potential for growth and progress.
            </p>
          </div>
          <div class="iq-objectsnew">
            <span
              class="iq-objects-02"
              data-bottom="transform:translatey(50px)"
              data-top="transform:translatey(-100px);"
            >
              <img src="images/drive/03.png" class="img-fluid" alt="drive02" />
            </span>
            <span
              class="iq-objects-03"
              data-bottom="transform:translatex(50px)"
              data-top="transform:translatex(-100px);"
            >
              <img src="images/drive/04.png" class="img-fluid" alt="drive02" />
            </span>
            <span class="iq-objects-04 iq-fadebounce">
              <span class="iq-round"></span>
            </span>
          </div>
        </div>
      </div>
    </section>
    <section class="overview-block-ptb how-works r-mt-40">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <img
              class="iq-works-img pull-left img-fluid"
              src="images/about-us.jpeg"
              alt="drive01"
            />
          </div>
          <div class="col-lg-4 align-self-center">
            <span class="badge iq-badge blue-bg iq-font-white"
              >Our Mission</span
            >
            <h5 class="iq-tw-6 iq-mb-15 iq-font-10">
              Turning Vision into Reality Through Technology.
            </h5>
            <p class="iq-font-25" style="font-size: 18px">
              Our mission is to bridge the gap between ideas and impactful
              execution, helping businesses and individuals thrive in a
              technology-driven world.
            </p>
          </div>
          <div class="iq-objects-softwarenew">
            <span
              class="iq-objects-01"
              data-bottom="transform:translatey(50px)"
              data-top="transform:translatey(-100px);"
            >
              <img src="images/drive/03.png" alt="drive02" />
            </span>
            <span
              class="iq-objects-02"
              data-bottom="transform:translatex(50px)"
              data-top="transform:translatex(-100px);"
            >
              <img src="images/drive/04.png" alt="drive02" />
            </span>
            <span class="iq-objects-03 iq-fadebounce">
              <span class="iq-round"></span>
            </span>
          </div>
        </div>
      </div>
    </section>
    <section
      class="iq-feature1 overview-block-ptb grey-bg"
      id="software-features"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="heading-title text-center">
              <h2 class="title iq-tw-6">Our Great Services</h2>
              <p style="font-size: 20px">
                At Tamba Group, we provide innovative and tailored solutions
                that harness the power of technology to solve complex challenges
                and drive growth. Our range of services includes:
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-12 iq-mtb-15">
            <div class="service-card">
              <div class="service-icon">
                <i class="fa fa-code"></i>
              </div>
              <div class="service-content">
                <h5 class="service-title">Custom Software Development</h5>
                <p class="service-description">
                  Building scalable and user-friendly software solutions
                  tailored to your business needs, ensuring efficiency and
                  innovation.
                </p>
                <ul class="service-features">
                  <li><i class="fa fa-check"></i> Vue.js 3 & TypeScript</li>
                  <li><i class="fa fa-check"></i> Laravel Backend</li>
                  <li><i class="fa fa-check"></i> MySQL Database</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 iq-mtb-15">
            <div class="service-card">
              <div class="service-icon">
                <i class="fa fa-mobile"></i>
              </div>
              <div class="service-content">
                <h5 class="service-title">Web and Mobile App Development</h5>
                <p class="service-description">
                  Crafting intuitive and engaging digital experiences that
                  connect businesses with their customers across web and mobile
                  platforms.
                </p>
                <ul class="service-features">
                  <li><i class="fa fa-check"></i> React Native Apps</li>
                  <li><i class="fa fa-check"></i> Responsive Web Design</li>
                  <li><i class="fa fa-check"></i> Cross-Platform Solutions</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 iq-mtb-15">
            <div class="service-card">
              <div class="service-icon">
                <i class="fa fa-paint-brush"></i>
              </div>
              <div class="service-content">
                <h5 class="service-title">Creative Design and Branding</h5>
                <p class="service-description">
                  Delivering impactful designs and branding strategies that
                  elevate your business presence and communicate your vision
                  effectively.
                </p>
                <ul class="service-features">
                  <li><i class="fa fa-check"></i> Logo & Brand Identity</li>
                  <li><i class="fa fa-check"></i> UI/UX Design</li>
                  <li><i class="fa fa-check"></i> Marketing Materials</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 iq-mtb-15">
            <div class="service-card">
              <div class="service-icon">
                <i class="fa fa-lightbulb-o"></i>
              </div>
              <div class="service-content">
                <h5 class="service-title">Technology Consulting</h5>
                <p class="service-description">
                  Offering expert advice and strategic guidance to help you
                  navigate and adopt the best technologies for your goals.
                </p>
                <ul class="service-features">
                  <li><i class="fa fa-check"></i> Technology Strategy</li>
                  <li><i class="fa fa-check"></i> Digital Transformation</li>
                  <li><i class="fa fa-check"></i> Architecture Planning</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 iq-mtb-15">
            <div class="service-card">
              <div class="service-icon">
                <i class="fa fa-cogs"></i>
              </div>
              <div class="service-content">
                <h5 class="service-title">IT Support and Maintenance</h5>
                <p class="service-description">
                  Providing reliable IT support and proactive maintenance to
                  ensure seamless operation and minimal downtime for your
                  business systems.
                </p>
                <ul class="service-features">
                  <li><i class="fa fa-check"></i> 24/7 Monitoring</li>
                  <li><i class="fa fa-check"></i> DigitalOcean Hosting</li>
                  <li><i class="fa fa-check"></i> Security Updates</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 iq-mtb-15">
            <div class="service-card">
              <div class="service-icon">
                <i class="fa fa-line-chart"></i>
              </div>
              <div class="service-content">
                <h5 class="service-title">Data Analytics and Insights</h5>
                <p class="service-description">
                  Empowering businesses to make informed decisions by
                  transforming raw data into actionable insights using advanced
                  analytics tools.
                </p>
                <ul class="service-features">
                  <li><i class="fa fa-check"></i> Business Intelligence</li>
                  <li><i class="fa fa-check"></i> Performance Analytics</li>
                  <li><i class="fa fa-check"></i> Custom Dashboards</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="overview-block-ptb">
      <div class="container">
        <div class="row align-items-center text-center text-lg-left">
          <div
            class="col-12 col-md-12 col-lg-6 mr-lg-auto text-center text-md-left"
          >
            <h3 class="iq-tw-6 iq-mb-15">Software Features</h3>
            <p class="iq-font-15">
              Simply dummy text of the printing and typesetting industry. Lorem
              Ipsum has been the industry's standard dummy text ever since the
              1500s, when an unknown printer took a galley of type and scrambled
              it to make a type specimen book.
            </p>
          </div>
          <div class="col-12 col-md-12 col-lg-5">
            <div class="row no-gutters">
              <div class="col-6 mb-3 pr-3">
                <div class="iq-shadow d-flex align-items-center flex-wrap">
                  <i class="ion-ios-person-outline" aria-hidden="true"></i>
                  <div class="text-left">
                    <span
                      class="timer iq-tw-7 iq-font-30"
                      data-to="800"
                      data-speed="10000"
                      >1540</span
                    >
                    <p class="m-0">Users</p>
                  </div>
                </div>
              </div>
              <div class="col-6 mb-3">
                <div class="iq-shadow d-flex align-items-center flex-wrap">
                  <i class="ion-ios-folder-outline" aria-hidden="true"></i>
                  <div class="text-left">
                    <span
                      class="timer iq-tw-7 iq-font-30"
                      data-to="400"
                      data-speed="10000"
                      >1540</span
                    >
                    <p class="m-0">Downloads</p>
                  </div>
                </div>
              </div>
              <div class="col-6 pr-3">
                <div class="iq-shadow d-flex align-items-center flex-wrap">
                  <i class="ion-ios-star" aria-hidden="true"></i>
                  <div class="text-left">
                    <span
                      class="timer iq-tw-7 iq-font-30"
                      data-to="306"
                      data-speed="10000"
                      >1540</span
                    >
                    <p class="m-0">App Rate</p>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div
                  class="iq-shadow d-flex align-items-center flex-wrap blue-bg"
                >
                  <i
                    class="ion-ios-paper-outline iq-font-white"
                    aria-hidden="true"
                  ></i>
                  <div class="text-left">
                    <span
                      class="timer iq-tw-7 iq-font-30 iq-font-white"
                      data-to="450"
                      data-speed="10000"
                      >1540</span
                    >
                    <p class="m-0 iq-font-white">Projects</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- our team -->
    <!-- <section class="overview-block-ptb blue-bg" id="team">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 iq-font-white">
            <div class="heading-title white text-center">
              <h2 class="title white iq-tw-6 iq-font-white">
                Meet Our Creative Team
              </h2>
              <p>
                Lorem Ipsum is simply dummy text ever sincehar the 1500s, when
                an unknownshil printer took a galley of type and scrambled it to
                make a type specimen book.It has survived not only five
                centuries.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-sm-6 iq-mtb-15">
            <div class="iq-team2 text-center">
              <div class="team-content">
                <img alt="" class="img-fluid" src="images/team/small/tambapic.jpeg" />
              </div>
              <div class="avtar-name iq-mt-20 iq-font-white text-center">
                <a href="team-details-1.html">
                  <h6 class="iq-font-white iq-tw-6">Heritier Ganza Tamba</h6>
                </a>
                <span>Software Engineer</span>
              </div>
              <div class="team-social iq-mt-10">
                <ul class="list-inline">
                  <li>
                    <a href="#"> <i class="fa fa-facebook"></i> </a>
                  </li>
                  <li>
                    <a href="#"> <i class="fa fa-twitter"></i> </a>
                  </li>
                  <li>
                    <a href="#"> <i class="fa fa-pinterest-p"></i> </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- our team  end-->
    <!-- Our Products -->
    <section id="products" class="overview-block-ptb grey-bg iq-blog">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="heading-title">
              <h3 class="title iq-tw-7">Our Products & Solutions</h3>
              <p>
                Explore our innovative products and solutions designed to help businesses thrive in the digital world.
                From web applications to mobile solutions, we deliver cutting-edge technology tailored to your needs.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div
              class="owl-carousel"
              data-autoplay="true"
              data-loop="true"
              data-nav="false"
              data-dots="true"
              data-items="3"
              data-items-laptop="3"
              data-items-tab="2"
              data-items-mobile="1"
              data-items-mobile-sm="1"
              data-margin="30"
            >
              <div class="item">
                <div class="iq-blog-box product-card">
                  <div class="iq-blog-image clearfix">
                    <img
                      class="img-fluid center-block"
                      src="images/clients/kigaliselfdrive.jpeg"
                      alt="Kigali Self Drive - Car Rental Platform"
                    />
                    <div class="product-overlay">
                      <div class="product-actions">
                        <a href="/product/kigali-self-drive" class="button bt-black">View Details</a>
                        <a href="https://kigaliselfdrive.com" target="_blank" class="button bt-white">Visit Site</a>
                      </div>
                    </div>
                  </div>
                  <div class="iq-blog-detail">
                    <div class="blog-title">
                      <a href="/product/kigali-self-drive">
                        <h5 class="iq-tw-6 iq-mb-10">
                          Kigali Self Drive
                        </h5>
                      </a>
                    </div>
                    <div class="blog-content">
                      <p>
                        A comprehensive car rental platform that connects travelers with reliable vehicle rental services in Kigali.
                        Features include real-time booking, payment processing, and customer management.
                      </p>
                    </div>
                    <div class="iq-blog-meta">
                      <ul class="list-inline">
                        <li class="list-inline-item">
                          <a href="javascript:void(0)"
                            ><i class="fa fa-tag" aria-hidden="true"></i>
                            Web Application</a
                          >
                        </li>
                        <li class="list-inline-item">
                          <a href="javascript:void(0)"
                            ><i class="fa fa-calendar" aria-hidden="true"></i>
                            Live Project</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="iq-blog-box product-card">
                  <div class="iq-blog-image clearfix">
                    <img
                      class="img-fluid center-block"
                      src="images/clients/estaterwanda.png"
                      alt="Estate Rwanda - Property Management Platform"
                    />
                    <div class="product-overlay">
                      <div class="product-actions">
                        <a href="/product/estate-rwanda" class="button bt-black">View Details</a>
                        <a href="https://estaterwanda.com" target="_blank" class="button bt-white">Visit Site</a>
                      </div>
                    </div>
                  </div>
                  <div class="iq-blog-detail">
                    <div class="blog-title">
                      <a href="/product/estate-rwanda">
                        <h5 class="iq-tw-6 iq-mb-10">
                          Estate Rwanda
                        </h5>
                      </a>
                    </div>
                    <div class="blog-content">
                      <p>
                        A comprehensive property management platform for buying, selling, and renting properties in Rwanda.
                        Features include property listings, virtual tours, and secure transaction processing.
                      </p>
                    </div>
                    <div class="iq-blog-meta">
                      <ul class="list-inline">
                        <li class="list-inline-item">
                          <a href="javascript:void(0)"
                            ><i class="fa fa-tag" aria-hidden="true"></i>
                            Property Platform</a
                          >
                        </li>
                        <li class="list-inline-item">
                          <a href="javascript:void(0)"
                            ><i class="fa fa-calendar" aria-hidden="true"></i>
                            Live Project</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="iq-blog-box product-card">
                  <div class="iq-blog-image clearfix">
                    <img
                      class="img-fluid center-block"
                      src="images/clients/logo.jpeg"
                      alt="50-30-20 Budgeting App"
                    />
                    <div class="product-overlay">
                      <div class="product-actions">
                        <a href="/product/budgeting-app" class="button bt-black">View Details</a>
                        <a href="#" class="button bt-white">Coming Soon</a>
                      </div>
                    </div>
                  </div>
                  <div class="iq-blog-detail">
                    <div class="blog-title">
                      <a href="/product/budgeting-app">
                        <h5 class="iq-tw-6 iq-mb-10">
                          50-30-20 Budgeting App
                        </h5>
                      </a>
                    </div>
                    <div class="blog-content">
                      <p>
                        A smart budgeting application that helps users manage their finances using the proven 50-30-20 rule:
                        50% for needs, 30% for wants, and 20% for savings and investments.
                      </p>
                    </div>
                    <div class="iq-blog-meta">
                      <ul class="list-inline">
                        <li class="list-inline-item">
                          <a href="javascript:void(0)"
                            ><i class="fa fa-tag" aria-hidden="true"></i>
                            Mobile App</a
                          >
                        </li>
                        <li class="list-inline-item">
                          <a href="javascript:void(0)"
                            ><i class="fa fa-calendar" aria-hidden="true"></i>
                            In Development</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="iq-blog-box product-card">
                  <div class="iq-blog-image clearfix">
                    <img
                      class="img-fluid center-block"
                      src="/images/clients/kinelogo.png"
                      alt="Kinezor Clothing - E-commerce Platform"
                    />
                    <div class="product-overlay">
                      <div class="product-actions">
                        <a href="/product/kinezor" class="button bt-black">View Details</a>
                        <a href="https://kinezorclothing.com" target="_blank" class="button bt-white">Visit Site</a>
                      </div>
                    </div>
                  </div>
                  <div class="iq-blog-detail">
                    <div class="blog-title">
                      <a href="/product/kinezor">
                        <h5 class="iq-tw-6 iq-mb-10">
                          Kinezor Clothing
                        </h5>
                      </a>
                    </div>
                    <div class="blog-content">
                      <p>
                        A comprehensive e-commerce platform for Kinezor brand clothing. Features include product listings,
                        shopping cart, secure checkout, and customer management for branded clothing sales.
                      </p>
                    </div>
                    <div class="iq-blog-meta">
                      <ul class="list-inline">
                        <li class="list-inline-item">
                          <a href="javascript:void(0)"
                            ><i class="fa fa-tag" aria-hidden="true"></i>
                            E-commerce Platform</a
                          >
                        </li>
                        <li class="list-inline-item">
                          <a href="javascript:void(0)"
                            ><i class="fa fa-calendar" aria-hidden="true"></i>
                            Live Project</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="iq-blog-box product-card">
                  <div class="iq-blog-image clearfix">
                    <img
                      class="img-fluid center-block"
                      src="/images/clients/rwandacarhire.png"
                      alt="Rwanda Car Hire - Car Rental Platform"
                    />
                    <div class="product-overlay">
                      <div class="product-actions">
                        <a href="/product/rwanda-car-hire" class="button bt-black">View Details</a>
                        <a href="https://kigalirwandacarhire.com" target="_blank" class="button bt-white">Visit Site</a>
                      </div>
                    </div>
                  </div>
                  <div class="iq-blog-detail">
                    <div class="blog-title">
                      <a href="/product/rwanda-car-hire">
                        <h5 class="iq-tw-6 iq-mb-10">
                          Rwanda Car Hire
                        </h5>
                      </a>
                    </div>
                    <div class="blog-content">
                      <p>
                        A premium car rental platform offering reliable vehicle rental services in Rwanda.
                        Features include online booking, secure payment processing, and excellent customer service.
                      </p>
                    </div>
                    <div class="iq-blog-meta">
                      <ul class="list-inline">
                        <li class="list-inline-item">
                          <a href="javascript:void(0)"
                            ><i class="fa fa-tag" aria-hidden="true"></i>
                            Car Rental Platform</a
                          >
                        </li>
                        <li class="list-inline-item">
                          <a href="javascript:void(0)"
                            ><i class="fa fa-calendar" aria-hidden="true"></i>
                            Live Project</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Our Products END -->

    <!-- Testimonials Section -->
    <section class="overview-block-ptb" style="background: linear-gradient(135deg, #6b700e 0%, #333 100%);">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="heading-title text-center">
              <h2 class="title iq-tw-6 iq-font-white">What Our Clients Say</h2>
              <p class="iq-font-white" style="font-size: 18px;">
                Don't just take our word for it. Here's what our satisfied clients have to say about working with Tamba Group.
              </p>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-6 col-sm-12 iq-mtb-15">
            <div class="testimonial-card">
              <div class="testimonial-header">
                <div class="client-info">
                  <div class="client-avatar">
                    <div class="avatar-initials avatar-blue">JP</div>
                  </div>
                  <div class="client-details">
                    <h5 class="client-name">Jean Paul</h5>
                    <p class="client-title">CEO, Estate Rwanda</p>
                  </div>
                </div>
                <div class="quote-icon">
                  <i class="fa fa-quote-right"></i>
                </div>
              </div>
              <div class="testimonial-body">
                <p class="testimonial-text">
                  "Tamba Group transformed our property business with their innovative platform.
                  The user experience is exceptional, and our sales have increased by 300% since launch."
                </p>
                <div class="testimonial-rating">
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 iq-mtb-15">
            <div class="testimonial-card">
              <div class="testimonial-header">
                <div class="client-info">
                  <div class="client-avatar">
                    <div class="avatar-initials avatar-green">SM</div>
                  </div>
                  <div class="client-details">
                    <h5 class="client-name">Sarah Mukamana</h5>
                    <p class="client-title">Founder, Kinezor Clothing</p>
                  </div>
                </div>
                <div class="quote-icon">
                  <i class="fa fa-quote-right"></i>
                </div>
              </div>
              <div class="testimonial-body">
                <p class="testimonial-text">
                  "Working with Tamba Group was a game-changer. They built our e-commerce platform
                  with such attention to detail. Our online sales have skyrocketed!"
                </p>
                <div class="testimonial-rating">
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 iq-mtb-15">
            <div class="testimonial-card">
              <div class="testimonial-header">
                <div class="client-info">
                  <div class="client-avatar">
                    <div class="avatar-initials avatar-purple">DN</div>
                  </div>
                  <div class="client-details">
                    <h5 class="client-name">David Nkurunziza</h5>
                    <p class="client-title">Manager, Rwanda Car Hire</p>
                  </div>
                </div>
                <div class="quote-icon">
                  <i class="fa fa-quote-right"></i>
                </div>
              </div>
              <div class="testimonial-body">
                <p class="testimonial-text">
                  "The car rental platform they built for us is simply outstanding.
                  Professional, reliable, and always available for support. Highly recommended!"
                </p>
                <div class="testimonial-rating">
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Testimonials END -->

    <!-- Why Choose Us Section -->
    <section class="overview-block-ptb iq-feature1 grey-bg">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="heading-title text-center">
              <h2 class="title iq-tw-6">Why Choose Tamba Group?</h2>
              <p style="font-size: 18px;">
                We're not just developers; we're your technology partners committed to your success.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-12 iq-mtb-15">
            <div class="iq-blog text-center iq-ptb-30 iq-pr-30 iq-pl-30">
              <div class="feature-icon" style="color: #6b700e; font-size: 48px; margin-bottom: 20px;">
                <i class="ion-ios-lightbulb-outline"></i>
              </div>
              <h5 class="iq-tw-6">Innovation First</h5>
              <p>We stay ahead of technology trends to deliver cutting-edge solutions that give you a competitive edge.</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 iq-mtb-15">
            <div class="iq-blog text-center iq-ptb-30 iq-pr-30 iq-pl-30">
              <div class="feature-icon" style="color: #6b700e; font-size: 48px; margin-bottom: 20px;">
                <i class="ion-ios-clock-outline"></i>
              </div>
              <h5 class="iq-tw-6">On-Time Delivery</h5>
              <p>We understand business timelines. Our projects are delivered on schedule, every time.</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 iq-mtb-15">
            <div class="iq-blog text-center iq-ptb-30 iq-pr-30 iq-pl-30">
              <div class="feature-icon" style="color: #6b700e; font-size: 48px; margin-bottom: 20px;">
                <i class="ion-ios-people-outline"></i>
              </div>
              <h5 class="iq-tw-6">Local Expertise</h5>
              <p>Based in Rwanda, we understand local business needs and market dynamics better than anyone.</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 iq-mtb-15">
            <div class="iq-blog text-center iq-ptb-30 iq-pr-30 iq-pl-30">
              <div class="feature-icon" style="color: #6b700e; font-size: 48px; margin-bottom: 20px;">
                <i class="ion-ios-headset-outline"></i>
              </div>
              <h5 class="iq-tw-6">24/7 Support</h5>
              <p>Our relationship doesn't end at launch. We provide ongoing support to ensure your success.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Why Choose Us END -->

    <!-- Clients -->
    <div class="iq-our-clients white-bg iq-ptb-50">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div
              class="owl-carousel"
              data-autoplay="true"
              data-loop="true"
              data-nav="true"
              data-dots="false"
              data-items="5"
              data-items-laptop="5"
              data-items-tab="4"
              data-items-mobile="3"
              data-items-mobile-sm="1"
              data-margin="30"
            >
              <div class="item">
                <img
                  class="img-fluid center-block"
                  src="images/clients/kigaliselfdrive.jpeg"
                  alt="#"
                />
              </div>
              <div class="item">
                <img
                  class="img-fluid center-block"
                  src="images/clients/simaza-logo-01png.png"
                  alt="#"
                />
              </div>
              <div class="item">
                <img
                  class="img-fluid center-block"
                  src="images/clients/kigalicarselfdrive.png"
                  alt="#"
                />
              </div>
              <div class="item">
                <img
                  class="img-fluid center-block"
                  src="images/clients/estaterwanda.png"
                  alt="Estate Rwanda"
                />
              </div>
              <div class="item">
                <img
                  class="img-fluid center-block"
                  src="images/clients/logo.jpeg"
                  alt="#"
                />
              </div>
              <div class="item">
                <img
                  class="img-fluid center-block"
                  src="images/clients/ag-pro.png"
                  alt="#"
                />
              </div>
              <div class="item">
                <img
                  class="img-fluid center-block"
                  src="images/clients/gli.png"
                  alt="#"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Clients END -->

    <!-- Footer Info -->
    <section id="contact-us" class="footer-info white-bg">
      <div class="container">
        <div class="row justify-content-end">
          <div class="col-md-6 col-lg-4">
            <div class="iq-get-in">
              <h4 class="iq-tw-7 iq-mb-20">Get in Touch</h4>
              <form method="post">
                <div class="contact-form">
                  <div class="section-field">
                    <input
                      class="require"
                      id="contact_name"
                      type="text"
                      placeholder="Name*"
                      name="name"
                    />
                  </div>
                  <div class="section-field">
                    <input
                      class="require"
                      id="contact_email"
                      type="email"
                      placeholder="Email*"
                      name="email"
                    />
                  </div>
                  <div class="section-field">
                    <input
                      class="require"
                      id="contact_phone"
                      type="text"
                      placeholder="Phone*"
                      name="phone"
                    />
                  </div>
                  <div class="section-field textarea">
                    <textarea
                      id="contact_message"
                      class="input-message require"
                      placeholder="Comment*"
                      rows="5"
                      name="message"
                    ></textarea>
                  </div>

                  <button type="button" value="Send" class="button iq-mt-15">
                    Send Message
                  </button>
                  <div
                    class="alert alert-success alert-dismissible fade show"
                    role="alert"
                    id="success"
                  >
                    <strong>Thank You, Your message has been received.</strong>.
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <iframe
        class="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3987.5086714499503!2d30.05756357496711!3d-1.9496425980326786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19dca514fa1ba555%3A0x74d2441e37428ac8!2sTamba%20Group!5e0!3m2!1sen!2srw!4v1736495256799!5m2!1sen!2srw"
        style="border: 0"
        allowfullscreen
      ></iframe>
    </section>
    <!-- Footer -->
    <footer id="contact" class="iq-footerr iq-ptb-40">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6 iq-mtb-20">
            <div class="logo">
              <img
                class="img-fluid logo_img"
                src="images/tg-logo2.png"
                alt="#"
              />
              <div class="iq-font-black iq-mt-15">
                At Tamba Group, we believe that every challenge holds the
                potential for growth and progress.
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 iq-mtb-20">
            <div class="contact-bg">
              <h5 class="iq-tw-6 iq-font-black iq-mb-10">Address</h5>
              <ul class="iq-contact">
                <li>
                  <i class="ion-ios-location-outline"></i>
                  <p>RN 3 Street, Giporoso, Remera Kigali RWANDA</p>
                </li>
                <li>
                  <i class="ion-ios-telephone-outline"></i>
                  <p>0789 326 245</p>
                </li>
                <li>
                  <i class="ion-ios-email-outline"></i>
                  <p>info@tambagroup.xyz</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 iq-mtb-20">
            <h5 class="iq-tw-6 iq-font-black iq-mb-10">Menu</h5>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <ul class="menu">
                  <li><a href="javascript:void(0)">Home</a></li>
                  <li><a href="javascript:void(0)">About Us</a></li>
                  <li><a href="javascript:void(0)">Our Team</a></li>
                  <li><a href="javascript:void(0)">Portfolio</a></li>
                </ul>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <ul class="menu">
                  <li><a href="javascript:void(0)">Faqs</a></li>
                  <li><a href="/#products">Products</a></li>
                  <li><a href="#">Our Services</a></li>
                  <li><a href="javascript:void(0)">Contact Us</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 iq-mtb-20">
            <h5 class="iq-tw-6 iq-font-black iq-mb-10">Help</h5>
            <ul class="office-day">
              <li>
                <a href="javascript:void(0)">Help Center</a>
              </li>
              <li>
                <a href="javascript:void(0)">Product</a>
              </li>
              <li>
                <a href="javascript:void(0)">Tool</a>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <div class="row iq-mt-20">
          <div class="col-auto mr-auto">
            <ul class="link">
              <li class="d-inline-block iq-mr-20">
                <a href="javascript:void(0)">Term and Condition</a>
              </li>
              <li class="d-inline-block">
                <a href="javascript:void(0)"> Privacy Policy</a>
              </li>
            </ul>
          </div>
          <div class="col-auto">
            <div class="iq-copyright">
              Copyright @ 2025
              <a href="#">Tamba Group</a> All Rights Reserved
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer END -->
    <!-- back-to-top -->
    <div id="back-to-top">
      <a class="top" id="top" href="#top">
        <i class="ion-ios-upload-outline"></i>
      </a>
    </div>
  </body>
</template>
<style scoped>
#main-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000; /* Ensure it stays on top of other elements */
  background-color: white; /* Optional: Ensure it has a background */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visibility */
}

/* Product Cards Styling */
.product-card {
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 8px;
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.product-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 8px;
}

.product-card:hover .product-overlay {
  opacity: 1;
}

.product-actions {
  text-align: center;
}

.product-actions .button {
  margin: 5px;
  min-width: 120px;
  display: inline-block;
  padding: 10px 20px;
  text-decoration: none;
  border-radius: 5px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.product-actions .button.bt-black {
  background-color: #333;
  color: white;
  border: 2px solid #333;
}

.product-actions .button.bt-black:hover {
  background-color: #6b700e;
  border-color: #6b700e;
  color: white;
}

.product-actions .button.bt-white {
  background-color: transparent;
  color: white;
  border: 2px solid white;
}

.product-actions .button.bt-white:hover {
  background-color: white;
  color: #333;
}

/* Enhanced product card content */
.product-card .iq-blog-detail {
  padding: 20px;
}

.product-card .blog-title a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s ease;
}

.product-card .blog-title a:hover {
  color: #6b700e;
}

.product-card .blog-content p {
  color: #666;
  line-height: 1.6;
}

.product-card .iq-blog-meta {
  margin-top: 15px;
}

.product-card .iq-blog-meta .list-inline-item a {
  color: #999;
  font-size: 14px;
  text-decoration: none;
}

.product-card .iq-blog-meta .list-inline-item a:hover {
  color: #6b700e;
}

/* Trust Indicators */
.trust-indicators {
  margin: 30px 0;
}

.stat-item h4 {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-item p {
  font-size: 14px;
  opacity: 0.9;
}

.cta-buttons {
  margin-top: 30px;
}

/* Testimonials */
.testimonial-card {
  background: rgba(255, 255, 255, 0.95);
  padding: 30px;
  border-radius: 15px;
  margin-bottom: 30px;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  height: 100%;
}

.testimonial-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
}

.testimonial-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.client-info {
  display: flex;
  align-items: center;
}

.client-avatar {
  margin-right: 15px;
}

.avatar-initials {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6b700e, #333);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  border: 3px solid #6b700e;
  text-transform: uppercase;
}

.avatar-blue {
  background: linear-gradient(135deg, #3498db, #2980b9) !important;
  border-color: #3498db !important;
}

.avatar-green {
  background: linear-gradient(135deg, #27ae60, #229954) !important;
  border-color: #27ae60 !important;
}

.avatar-purple {
  background: linear-gradient(135deg, #8e44ad, #7d3c98) !important;
  border-color: #8e44ad !important;
}

.client-name {
  margin: 0;
  color: #333;
  font-weight: 600;
  font-size: 16px;
}

.client-title {
  margin: 0;
  color: #6b700e;
  font-size: 14px;
  font-weight: 500;
}

.quote-icon {
  color: #6b700e;
  font-size: 24px;
  opacity: 0.7;
}

.testimonial-text {
  color: #555;
  font-style: italic;
  margin-bottom: 20px;
  line-height: 1.6;
}

.testimonial-rating {
  color: #ffc107;
}

.testimonial-rating i {
  margin-right: 3px;
}

/* Services */
.service-card {
  background: white;
  padding: 40px 30px;
  border-radius: 15px;
  margin-bottom: 30px;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  height: 100%;
  border: 1px solid #f0f0f0;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  border-color: #6b700e;
}

.service-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #6b700e, #333);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  transition: transform 0.3s ease;
}

.service-card:hover .service-icon {
  transform: scale(1.1);
}

.service-icon i {
  color: white;
  font-size: 32px;
}

.service-title {
  color: #333;
  font-weight: 600;
  margin-bottom: 15px;
  text-align: center;
  font-size: 20px;
}

.service-description {
  color: #666;
  text-align: center;
  margin-bottom: 25px;
  line-height: 1.6;
}

.service-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.service-features li {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  color: #555;
  font-size: 14px;
}

.service-features li i {
  color: #6b700e;
  margin-right: 10px;
  font-size: 12px;
}

/* Feature Icons */
.feature-icon {
  transition: transform 0.3s ease;
}

.feature-icon:hover {
  transform: scale(1.1);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .product-actions .button {
    min-width: 100px;
    padding: 8px 16px;
    font-size: 14px;
  }

  .stat-item h4 {
    font-size: 28px;
  }

  .cta-buttons .button {
    display: block;
    margin-bottom: 15px;
    width: 100%;
  }

  .testimonial-header {
    flex-direction: column;
    text-align: center;
  }

  .client-info {
    justify-content: center;
    margin-bottom: 15px;
  }

  .quote-icon {
    align-self: center;
  }

  .service-card {
    padding: 30px 20px;
  }

  .service-icon {
    width: 60px;
    height: 60px;
  }

  .service-icon i {
    font-size: 24px;
  }
}
</style>
